// Spanish-first copy for the try-on UI. Flat key map keeps it trivial to add a
// second locale later (the brief leaves multi-region open). The engine emits
// i18n keys (e.g. `error.permission-denied`); the UI resolves them here.

export type Locale = 'es';

const es: Record<string, string> = {
  'launch.button': 'Probar en casa',
  'launch.subtitle': 'Pruébatelos con tu cámara, sin salir de la página.',

  'consent.title': 'Probador virtual',
  'consent.body':
    'Usamos tu cámara solo en tu dispositivo para mostrarte cómo te quedan. Tu rostro no se graba ni se envía a ningún servidor.',
  'consent.accept': 'Activar cámara',
  'consent.cancel': 'Ahora no',

  'loading.sdk': 'Preparando el probador…',
  'loading.camera': 'Activando la cámara…',

  'hint.no-face': 'Acércate y mira a la cámara',
  'hint.too-far': 'Acércate un poco',
  'hint.too-close': 'Aléjate un poco',
  'hint.extreme-angle': 'Mira de frente a la cámara',
  'hint.low-light': 'Mejora la iluminación',
  'hint.multi-face': 'Que solo aparezca un rostro',

  'fit.narrow': 'Te queda estrecho',
  'fit.fits': 'Te queda bien',
  'fit.wide': 'Te queda ancho',
  'fit.label': 'Ajuste estimado',

  'pd.label': 'Distancia pupilar (DP)',
  'pd.measuring': 'Midiendo…',
  'pd.disclaimer':
    'Estimación orientativa. Para tu graduación, confírmala con tu óptico.',
  'pd.manual': 'Introducir manualmente',

  'shape.label': 'Forma de rostro',
  'shape.oval': 'Ovalado',
  'shape.round': 'Redondo',
  'shape.square': 'Cuadrado',
  'shape.heart': 'Corazón',
  'shape.oblong': 'Alargado',
  'shape.recommends': 'Te favorecen',

  'controls.capture': 'Capturar',
  'controls.close': 'Cerrar',
  'controls.color': 'Color',

  'error.permission-denied':
    'No pudimos acceder a la cámara. Revisa los permisos del navegador.',
  'error.no-camera': 'No encontramos ninguna cámara en este dispositivo.',
  'error.camera-in-use':
    'La cámara está en uso por otra aplicación. Ciérrala e inténtalo de nuevo.',
  'error.insecure-context': 'El probador necesita una conexión segura (HTTPS).',
  'error.webview':
    'Abre la página en tu navegador (Safari o Chrome) para usar el probador.',
  'error.unsupported': 'Tu navegador no es compatible con el probador.',
  'error.webgl-failed': 'Tu dispositivo no admite el render 3D necesario.',
  'error.sdk-load-failed': 'No pudimos cargar el probador. Inténtalo de nuevo.',
  'error.unknown': 'Algo salió mal. Inténtalo de nuevo.',
  'error.fallback3d': 'Mira el modelo en 3D mientras tanto.',
  'error.retry': 'Reintentar',
};

export function t(key: string): string {
  return es[key] ?? key;
}

export const STYLE_LABELS: Record<string, string> = {
  square: 'cuadradas',
  rectangular: 'rectangulares',
  aviator: 'aviador',
  wayfarer: 'wayfarer',
  geometric: 'geométricas',
  round: 'redondas',
  oval: 'ovaladas',
  'cat-eye': 'ojo de gato',
  rimless: 'sin montura',
  oversized: 'grandes',
};
